import { useHasSession } from "@/hooks/useHasSession"
import { useAppSelector } from "@/store"
import { useGetInventoryQuery } from "@/store/apis/inventoryAPI"
import { PlayerSelectors } from "@/store/slices/player"

/**
 * FE facade for the player's load ratio (ADR-0004: served ready-made by
 * GET /inventory/me — never recomputed client-side). Loading, skipped,
 * and capacity<=0 all collapse to null.
 */
export const useEncumbrance = (): number | null => {
  const hasSession = useHasSession()
  const isPlayerLoaded = useAppSelector(PlayerSelectors.selectIsPlayerLoaded())

  const { loadRatio } = useGetInventoryQuery(undefined, {
    skip: !hasSession || !isPlayerLoaded,
    selectFromResult: ({ data }) => ({
      // weight is also optional-chained: a contract-violating 200 without it
      // must degrade to an empty gauge, not crash the app shell in render
      loadRatio: data?.weight?.loadRatio ?? null
    })
  })

  return loadRatio
}
